import React from "react";
import { Box } from "@chakra-ui/react";
import useApi from "../../../api/hooks/useApi";
import { VeriDropZone } from "../../form-controls";
import { Button } from "../../common/Button";
import { VeriDrawer } from "../../drawers";
import { ManagerModel } from "../../../api/models";
import { useVeriToast } from "../../../hooks";

export interface TrackRecordUploadDocumentProps {
  manager: ManagerModel;
  onClose: () => void;
}

export const TrackRecordUploadDocuments: React.FC<
  TrackRecordUploadDocumentProps
> = ({ manager, onClose }) => {
  const toast = useVeriToast();
  const api = useApi();
  const [isLoading, setIsLoading] = React.useState(false);
  const [selectedFiles, setSelectedFiles] = React.useState<
    | {
        uploading: boolean;
        file: File;
      }[]
  >([]);

  const uploadDocuments = async () => {
    setIsLoading(true);

    let someSuccess = false;

    await setSelectedFiles((files) =>
      files.map((file) => ({ ...file, uploading: true })),
    );

    try {
      for (let i = 0; i < selectedFiles.length; i++) {
        try {
          await api.uploadRequest(
            "track-records/documents",
            selectedFiles[i].file,
            {
              filename: selectedFiles[i].file.name,
              manager_id: manager.id,
              email_notification: true,
            },
            () => null,
            true,
          );

          await setSelectedFiles((files) =>
            files.map((file, index) =>
              index === i ? { ...file, success: true, error: false } : file,
            ),
          );

          someSuccess = true;
        } catch (error) {
          await setSelectedFiles((files) =>
            files.map((file, index) =>
              index === i ? { ...file, success: false, error: true } : file,
            ),
          );

          toast.toastServerError(
            error,
            "Something went wrong uploading " +
              (selectedFiles[i].file?.name || "the file"),
          );
        }
      }
      if (someSuccess) {
        toast.toastSuccess("Documents uploaded");
      }
    } catch (error) {
      //
    }

    onClose();
  };

  return (
    <VeriDrawer
      variant={"form-alt"}
      size={"lg"}
      title={"Upload documents"}
      onClose={onClose}
      secondaryButton={() => (
        <Button isLarge empty onClick={onClose}>
          Cancel
        </Button>
      )}
      primaryButton={() => (
        <Button
          w="100%"
          onClick={uploadDocuments}
          isLoading={isLoading}
          isDisabled={!selectedFiles?.length}
          isLarge
        >
          Save
        </Button>
      )}
      isOpen
    >
      Securely upload your supporting track record documents below to share with
      the Verivest Investment Manager Success team.
      <Box mt={6}>
        <VeriDropZone
          files={selectedFiles}
          onChange={(files) => setSelectedFiles(files)}
          dropTypeText={"document(s)"}
          multiple
        />
      </Box>
    </VeriDrawer>
  );
};
